import React from "react"
import classes from "./MobileNav.module.scss"
import { useStaticQuery, graphql, Link } from "gatsby"

const MobileNav = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        sort: { order: ASC, fields: frontmatter___image___birthtime }
      ) {
        nodes {
          id
          frontmatter {
            title
            postType
          }
          fields {
            slug
          }
        }
      }
    }
  `)
  return <div className={classes.MobileNav}></div>
}

export default MobileNav
